import { Injectable, inject } from "@angular/core";
import { HttpBaseService } from "../base_services/http_base.service";
import { HttpClient } from "@angular/common/http";
import { LocalRepository } from "@shared/helper/local-repository";
import { Observable } from "rxjs";
import { TServiceResult } from "@shared/helper/t-service-result";
import { PageList } from "@shared/model/categoryAndSearch/pageList-model";
import { IGetUnseenbadgeDto } from "@shared/model/badge/get-unseen-badge.model";

@Injectable({
    providedIn: 'root'
})
export class BadgeService extends HttpBaseService {
    constructor() {
        const http = inject(HttpClient);
        const repo = inject(LocalRepository);

        super(repo , http , 'bdg')
    }

    getUnseenbadge(): Observable<TServiceResult<PageList<IGetUnseenbadgeDto>>> {
        return this.http.get<TServiceResult<PageList<IGetUnseenbadgeDto>>>(`${this.apiUrl}/getUnseenBadge`)
    }

    seenAlluserBadge(): Observable<TServiceResult<any>> {
        return this.http.put<TServiceResult<any>>(`${this.apiUrl}/seenAlluserBadge` , null)
    }

    seenBadgesById(id: string[]): Observable<TServiceResult<string>> {
        return this.http.put<TServiceResult<string>>(`${this.apiUrl}/seenBadgesByIds` , id)
    }
}